/*
 * Virtual Closet on the store (rubies-ecom-v4). Runs on every page, does
 * nothing unless the shopper arrived from a centre's closet link.
 *
 * How the store learns about the closet: the closet service lands the
 * shopper on a product or collection with `?vc=slug|code|tappedAt|name|used`.
 * This script keeps that in a cookie for 30 days (a spent 20% until the
 * programme year ends, August 31 New York time), fills the bar under the
 * announcements, and writes the centre onto the cart as attributes (Closet,
 * Closet since, Closet name) so the order carries it and the ledger can
 * credit the centre even when there is no code on the order.
 *
 * States:
 *   shopping  a VC- code is in the cart: 20% applied, a quarter goes to the closet
 *   returning came back within 30 days, no code in the cart: the credit still stands
 *   used      the 20% was already spent (cookie flag from the closet service, or
 *             the signed-in customer's tag): say so before checkout does
 *   spent     the code was used on an order: the cookie keeps it, marked used,
 *             so the next tap at any closet gives no second 20% (2026-10-16)
 */
(function () {
  var COOKIE = 'vc_closet';
  var DAYS = 30;
  var DISMISS_KEY = 'vc_closet_dismissed';
  var SERVICE = 'https://closet.rubyshines.com';

  function readCookie(name) {
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf(name + '=') === 0) return decodeURIComponent(p.slice(name.length + 1));
    }
    return null;
  }
  // One cookie for the whole domain: the closet service (closet.rubyshines.com)
  // sets the same one on a tap, so the store has the closet even when the
  // landing query is lost (Shopify's theme preview rewrites it).
  var DOMAIN = /(^|\.)rubyshines\.com$/i.test(location.hostname) ? '; Domain=.rubyshines.com' : '';
  function writeCookie(name, value, seconds) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + DOMAIN + '; Path=/; SameSite=Lax; Max-Age=' + seconds + secure;
  }
  // A spent 20% is remembered until the programme year ends (September 1,
  // 04:00 UTC, as virtual-closet/lib/discounts.js), so a tap more than 30 days
  // later still gets no second 20%. An unused tap lasts the 30-day window.
  function keepFor(c) {
    if (!c.used) return DAYS * 86400;
    var now = Date.now();
    var y = new Date(now).getUTCFullYear();
    var end = Date.UTC(y, 8, 1, 4);
    if (now >= end) end = Date.UTC(y + 1, 8, 1, 4);
    return Math.floor((end - now) / 1000);
  }
  function clearCookie(name) {
    document.cookie = name + '=' + DOMAIN + '; Path=/; SameSite=Lax; Max-Age=0';
    document.cookie = name + '=; Path=/; SameSite=Lax; Max-Age=0';
  }
  function parse(raw) {
    if (!raw) return null;
    // Shopify's discount redirect re-encodes the landing path, so the value
    // can arrive percent-encoded one level deeper than we sent it. Peel until
    // the pipes show.
    var guard = 0;
    while (raw.indexOf('|') < 0 && /%[0-9A-Fa-f]{2}/.test(raw) && guard++ < 3) {
      try { raw = decodeURIComponent(raw); } catch (e) { break; }
    }
    var f = raw.split('|');
    if (f.length < 3 || !f[0] || !f[1]) return null;
    // f[5] is 'resource' for a resource page (2026-10-19): 20% off, nothing to the org.
    return { slug: f[0], code: f[1], since: parseInt(f[2], 10) || Date.now(), name: f[3] || '', used: f[4] === 'used', resource: f[5] === 'resource' };
  }
  function serialize(c) {
    var f = [c.slug, c.code, c.since, c.name, c.used ? 'used' : ''];
    if (c.resource) f.push('resource');
    return f.join('|');
  }

  // 1. Landing parameter beats the cookie: a new tap restarts the window.
  var closet = null;
  var params = new URLSearchParams(location.search);
  if (params.get('vc')) {
    closet = parse(params.get('vc'));
    if (closet) {
      writeCookie(COOKIE, serialize(closet), keepFor(closet));
      try { sessionStorage.removeItem(DISMISS_KEY); } catch (e) {}
    }
  }
  // A tap just now: the landing parameter, or the centre page's note (vc-closet.js).
  var fresh = !!closet;
  if (!closet) closet = parse(readCookie(COOKIE));
  try {
    if (closet && sessionStorage.getItem('vc_closet_fresh') === closet.code) fresh = true;
    sessionStorage.removeItem('vc_closet_fresh');
  } catch (e) {}
  if (!closet) return;
  // Past the 30-day window the store treats the shopper as anyone else; a
  // spent 20% stays in the cookie so the next tap still knows.
  if (Date.now() - closet.since > DAYS * 86400000) { if (!closet.used) clearCookie(COOKIE); return; }

  // A closet shopper already has 20%: no email sign-up popup offering 10%
  // (hidden by the rule in component-vc-pages.css, inlined in theme.liquid).
  document.documentElement.classList.add('vc-shopper');

  var bar = document.querySelector('[data-closet-bar]');
  var usedByTag = bar && bar.getAttribute('data-used-tag') === 'true';

  function copy(key) {
    var text = bar ? bar.getAttribute('data-copy-' + key) || '' : '';
    var name = closet.name || 'the centre';
    return text.split('[centre]').join('<b>' + escapeHtml(name) + '</b>');
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isClosetTitle(t) { return /^VC-/i.test(String(t || '')) || /Virtual Closet/i.test(String(t || '')); }
  // The closet code is a product discount, so it sits on the lines; a
  // cart-level entry is checked too in case the discount is ever reshaped.
  function cartHasCode(cart) {
    if (!cart) return false;
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) if (isClosetTitle(apps[i].title)) return true;
    var items = cart.items || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) if (allocs[k].discount_application && isClosetTitle(allocs[k].discount_application.title)) return true;
    }
    return false;
  }

  // The closet line takes the announcement bar's place rather than adding
  // a second bar (Jamie, 2026-09-22): the announcements are hidden while the
  // closet line shows, and come back when it is dismissed or spent.
  function announcements(show) {
    var els = document.querySelectorAll('.announcement-bar-section');
    for (var i = 0; i < els.length; i++) els[i].style.display = show ? '' : 'none';
  }
  function hideBar() {
    if (bar) bar.hidden = true;
    announcements(true);
  }
  function showBar(cart) {
    if (!bar) return;
    // Only on the shopping site proper (Jamie, 2026-10-15): the org pages and
    // the centre pages (every section carrying .vcp) keep their announcements,
    // and the bar shows again everywhere else.
    if (document.querySelector('.vcp')) { hideBar(); return; }
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) {}
    if (dismissed) { hideBar(); return; }
    // The code only attaches to lines it covers (not a sponsorship or a gift
    // card), so judge "returning" only when the cart has such a line and no
    // closet code on it; an empty cart, or one of sponsorships, is still
    // shopping with 20% off.
    var items = (cart && cart.items) || [];
    var covered = items.some(function (i) { return i.product_type !== 'Virtual Closet' && !i.gift_card; });
    // The bar is for the 20% while it is there to use (Jamie, 2026-10-15). A
    // spent 20% (this year's tag or code) or a cart the code has fallen off
    // gets the regular announcements; the cart's closet line says it is used.
    if (closet.used || usedByTag || (covered && !cartHasCode(cart))) { hideBar(); return; }
    bar.querySelector('[data-closet-message]').innerHTML = copy(closet.resource ? 'resource' : 'shopping');
    announcements(false);
    bar.hidden = false;
  }

  // 2. The centre rides on the cart as attributes, written once per cart.
  var writing = false;
  function attributeCart(cart) {
    if (!cart || writing) return;
    var attrs = cart.attributes || {};
    var kind = closet.resource ? 'resource' : '';
    if (attrs['Closet'] === closet.slug && String(attrs['Closet since']) === String(closet.since) && (attrs['Closet kind'] || '') === kind) return;
    // A sponsor permalink sets Closet itself; leave it be, unless the shopper
    // has just tapped a closet: then the tap wins, or a cart left over from
    // an earlier closet credits the wrong centre with a stale tap date
    // (order #34242, 2026-10-16).
    if (attrs['Closet'] && attrs['Closet'] !== closet.slug && !fresh) return;
    writing = true;
    // Ask Shopify for the drawer's markup in the same call, so the closet
    // line appears the first time the drawer opens rather than after the
    // next quantity change. The swap mirrors what Dawn's cart-drawer.js does
    // on a cart change, without opening the drawer.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      // Closet kind: 'resource' tells the cart line there is no quarter to show.
      body: JSON.stringify({ attributes: { 'Closet': closet.slug, 'Closet since': String(closet.since), 'Closet name': closet.name, 'Closet kind': kind }, sections: 'cart-drawer' }),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { writing = false; swapDrawer(state && state.sections && state.sections['cart-drawer']); })
      .catch(function () { writing = false; });
  }

  function swapDrawer(html) {
    var target = document.getElementById('CartDrawer');
    if (!html || !target) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
    if (!fresh) return;
    target.innerHTML = fresh.innerHTML;
    if (typeof $ !== 'undefined') {
      if (typeof discountSubmitHandle !== 'undefined') $('.cartDiscountSubmit').off('click', discountSubmitHandle).on('click', discountSubmitHandle);
      if (typeof discountRemoveHandle !== 'undefined') $('.remove-discount').off('click', discountRemoveHandle).on('click', discountRemoveHandle);
    }
  }

  // Shopify keeps every code a cart has collected and applies only one of
  // two 20%s, so an old code (an event link's, a promo) can beat the code
  // just tapped (2026-10-15). Right after a tap, the cart is set to the
  // closet's code alone; later codes the shopper types are left alone.
  function preferClosetCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var others = codes.filter(function (c) { return String(c.code).toUpperCase() !== String(closet.code).toUpperCase(); });
    if (!fresh || closet.used || !others.length) return Promise.resolve(cart);
    fresh = false;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: closet.code, sections: 'cart-drawer' }),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { swapDrawer(state && state.sections && state.sections['cart-drawer']); return state; })
      .catch(function () { return cart; });
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(preferClosetCode)
      .then(function (cart) {
        showBar(cart);
        if (cart.item_count > 0) attributeCart(cart);
      })
      .catch(function () { showBar(null); });
  }

  // 3. Once the code has been spent on an order, the closet is done here.
  function checkSpent() {
    if (!closet.code) return;
    fetch(SERVICE + '/api/code/' + encodeURIComponent(closet.code), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.used) {
          // Remember it, don't forget it: the closet service reads this code
          // on the next tap and gives no second 20% this year.
          closet.used = true;
          writeCookie(COOKIE, serialize(closet), keepFor(closet));
          hideBar();
        }
      })
      .catch(function () {});
  }

  if (bar) {
    var close = bar.querySelector('[data-closet-dismiss]');
    if (close) close.addEventListener('click', function () {
      hideBar();
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    });
  }

  refresh();
  checkSpent();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) checkSpent(); });
})();
